/**
 * Newsletters Index
 * This file imports all newsletters and their metadata
 */

// Import all newsletter metadata
import newsletter202409Metadata from './newsletter-2024-09/metadata.json';
import newsletter202408Metadata from './newsletter-2024-08/metadata.json';
import newsletter202407Metadata from './newsletter-2024-07/metadata.json';

// Import all newsletter content by language
import newsletter202409En from './newsletter-2024-09/en.json';
import newsletter202409De from './newsletter-2024-09/de.json';
import newsletter202408En from './newsletter-2024-08/en.json';
import newsletter202408De from './newsletter-2024-08/de.json';
import newsletter202407En from './newsletter-2024-07/en.json';
import newsletter202407De from './newsletter-2024-07/de.json';

// Map newsletter slugs to their content
const newsletterContent = {
  'newsletter-2024-09': {
    en: newsletter202409En,
    de: newsletter202409De
  },
  'newsletter-2024-08': {
    en: newsletter202408En,
    de: newsletter202408De
  },
  'newsletter-2024-07': {
    en: newsletter202407En,
    de: newsletter202407De
  }
};

// All newsletter metadata
export const newsletterMetadata = [
  newsletter202409Metadata,
  newsletter202408Metadata,
  newsletter202407Metadata
];

/**
 * Get all newsletters with metadata, sorted by date (newest first)
 */
export function getAllNewsletters() {
  return newsletterMetadata
    .map(metadata => ({
      ...metadata,
      date: new Date(metadata.date)
    }))
    .sort((a, b) => b.date - a.date);
}

/**
 * Get a specific newsletter by slug
 * @param {string} slug - Newsletter slug
 * @param {string} language - Language code (en, de, etc.)
 * @returns {object|null} Newsletter with metadata and content, or null if not found
 */
export function getNewsletterBySlug(slug, language = 'en') {
  const metadata = newsletterMetadata.find(newsletter => newsletter.slug === slug);
  if (!metadata) {
    return null;
  }

  const content = newsletterContent[slug]?.[language] || newsletterContent[slug]?.['en'] || null;
  if (!content) {
    return null;
  }

  return {
    ...metadata,
    ...content,
    date: new Date(metadata.date)
  };
}

/**
 * Get newsletter content for a specific slug and language
 * @param {string} slug - Newsletter slug
 * @param {string} language - Language code
 * @returns {object|null} Newsletter content or null
 */
export function getNewsletterContent(slug, language = 'en') {
  return newsletterContent[slug]?.[language] || newsletterContent[slug]?.['en'] || null;
}

const newsletterExports = {
  getAllNewsletters,
  getNewsletterBySlug,
  getNewsletterContent,
  newsletterMetadata
};
export default newsletterExports;







